import { Component, computed, input, output } from '@angular/core';
import { BundleType, EntityTypeId, FieldName } from '../../models';

type SocialWallMediaType = 'image' | 'video' | 'audio';

const MEDIA_FIELDS: { field: string, type: SocialWallMediaType }[] = [
  { field: 'mediaImage', type: 'image' },
  { field: 'mediaVideo', type: 'video' },
  { field: 'mediaAudio', type: 'audio' }
];

@Component({
  selector: 'lib-social-wall-card',
  templateUrl: './social-wall-card.component.html',
  styleUrl: './social-wall-card.component.scss',
  standalone: false
})
export class SocialWallCardComponent {

  public readonly entityTypeId = EntityTypeId;
  public readonly bundleType = BundleType;
  public readonly fieldName = FieldName;

  public item = input<any>({});

  public open = output<void>();

  public media = computed<{ type: SocialWallMediaType, value: any } | null>(() => {
    const item = this.item();
    const media = MEDIA_FIELDS.find(({ field }) => !!item?.[field]);

    return media ? { type: media.type, value: item[media.field] } : null;
  });

}
